import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlogBlockImage } from '../blog.models';

@Component({
  selector: 'app-blog-block-image',
  templateUrl: './block-image.component.html',
  styleUrls: ['./block-image.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogBlockImageComponent {
  @Input({ required: true }) block!: BlogBlockImage;

  get alt(): string {
    return this.block?.alt || '';
  }
}
